<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-NoIndent__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span style=" font-style: italic; font-size: 1.00em;">“Environmentalists used to worry about the ramifications of reintroducing the gray wolf to Britain. What they didn’t understand was that we’ve never left.”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?267bcb80